import PropTypes from "prop-types";
import { SmileyRating } from "shared/ui-basics/ui-components/EmotionLevelComponents/SmileyRating";

function Score({ interaction, setInteraction, updateFunction, disabled }) {
	const { emotionLevel } = interaction;

	const handleClick = (lvl) => {
		const updatedLevel = lvl === emotionLevel ? -1 : lvl; // if the same level is clicked, set to -1
		setInteraction((prev) => ({ ...prev, emotionLevel: updatedLevel }));
		// if (updateFunction) updateFunction({ interaction: updatedInteraction });
	};

	return <SmileyRating emotionLevel={emotionLevel} onSelect={handleClick} isDisabled={disabled} />;
}

Score.displayName = "Score_EditInteraction";
Score.propTypes = {
	interaction: PropTypes.object,
	updateFunction: PropTypes.func,
};
export default Score;
